import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tenant-set-password',
  templateUrl: './tenant-set-password.component.html',
  styleUrls: ['./tenant-set-password.component.scss']
})
export class TenantSetPasswordComponent implements OnInit {

  public show: boolean = false;

  constructor() { }

  ngOnInit() {
  }

  showPassword() {
    this.show = !this.show;
  }

}
